<template>
    <div class="global-view-info-container">
        <h2 class="global-view-content-card-title">global view</h2>
        <ns-loader
            :to-load="toLoad"
            class="full-size"
            :scoped="false"
            style="margin-top: 15px;"
            @dataFetched="onDataFetched"
        >
            <div slot="loader" class="flex-center full-height">
                <loading-template></loading-template>
            </div>
            <template slot="content">
                <div class="global-view-content">
                    <div>
                        <div class="big-numbers-title">Running feeds</div>
                        <div class="big-numbers">
                            {{ runningFeeds }}
                        </div>
                    </div>
                    <div>
                        <div class="big-numbers-title" style="margin-bottom: 15px;">
                            next feed <template v-if="nextFeedStartDate">begins in</template>
                        </div>
                        <div>
                            <next-comming-feed :targetDate="nextFeedStartDate"></next-comming-feed>
                        </div>
                    </div>
                </div>
                <div class="global-view-content">
                    <div>
                        <div class="big-numbers-title">available FEEDS for the next 30 days</div>
                        <div class="big-numbers">
                            {{ scheduledFeeds }}
                        </div>
                    </div>
                    <div>
                        <div class="big-numbers-title">configured FEEDS for the next 30 days</div>
                        <div class="big-numbers">
                            {{ availableConfigurations }}
                        </div>
                    </div>
                </div>
            </template>
        </ns-loader>
    </div>
</template>

<script>
import { NextCommingFeed, LoadingTemplate } from 'gcmcn-common';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import InfoMixin  from '../../partials/global-view-info-mixin.vue';
export default {
    mixins: [InfoMixin],
    components: {
        LoadingTemplate,
        NextCommingFeed,
        NsLoader,
    },

    props: {

    },

    data (){
        return {
        };
    },

    computed: {
    },

    mounted (){
    },

    methods: {
    },
};
</script>

<style lang="scss">
.global-view-content-card-title {
    font-size: 18px;
}
.global-view-content{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    margin-top: 10px;
    height: 155px;
    .big-numbers-title-container{
        height: 33px;
        display: flex;
        .big-numbers-title{
            margin-top: auto;
        }
        .big-number-title-loading{
            opacity: .3;
        }
    }
    & > div{
        flex-basis: 46%;
        margin-bottom: 17px;
        &:nth-child(even){
            margin-left: 2%;
        }
        &:nth-child(odd){
            margin-right: 2%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/global-view.vue